<!-- FIRMA DE TANDA (solicitud del workflow; WFT-10). Sin diálogos: devolver se confirma en la página, con observación. -->
<div class="kb-page">
  <nav class="kb-migas" aria-label="Migas">
    <a routerLink="/console/altas">Altas de comercios</a><span aria-hidden="true">›</span><span>{{ f?.solicitud?.numero || 'Firma de tanda' }}</span>
  </nav>

  <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
    <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ error }}</p></div>
  </div>
  <div class="kb-cinta kb-cinta-info" *ngIf="aviso" role="status">
    <i class="fas fa-check-circle kb-cinta-icono" aria-hidden="true"></i><span>{{ aviso }}</span>
  </div>
  <app-cargando-cuadros *ngIf="cargando && !f" [tarjetas]="3" [filas]="4"></app-cargando-cuadros>

  <ng-container *ngIf="f">
    <div class="kb-page-header">
      <div>
        <h1 class="kb-page-title flex items-center gap-2"><i class="fas fa-file-signature text-[0.85em] text-muted-foreground" aria-hidden="true"></i>Tanda {{ f.tanda.n }} · liquidación del {{ f.dia | date:'dd/MM/yyyy':'UTC' }}</h1>
        <p class="kb-page-meta">{{ f.solicitud.tipo_nombre }} · {{ f.solicitud.numero }} · banda {{ f.tanda.banda.n }} ({{ firmantes(f.tanda.banda) }})</p>
      </div>
      <div class="text-right">
        <p class="m-0 text-2xl font-semibold tabular-nums"><app-monto-bs [usd]="f.tanda.monto" [bs]="bs(f.tanda.monto)" [tasa]="f.tasa" parte="principal"></app-monto-bs></p>
        <app-monto-bs [usd]="f.tanda.monto" [bs]="bs(f.tanda.monto)" [tasa]="f.tasa" parte="secundaria" subClass="block text-xs text-muted-foreground"></app-monto-bs>
        <span class="kb-badge mt-1" [ngClass]="estado.clase">{{ estado.texto }}</span>
      </div>
    </div>

    <div class="grid gap-[24px] lg:grid-cols-[1fr_300px]">
      <section class="kb-card min-w-0">
        <div class="kb-card-header">
          <div>
            <h2 class="kb-card-title">Comercios · {{ f.liquidaciones.length }}</h2>
            <p class="kb-card-desc" *ngIf="f.firmantes?.length && f.solicitud.estado === 'EN_CURSO'">Puede firmar: {{ (f.firmantes || []).map(nombre).join(', ') }}<ng-container *ngIf="f.firmaron?.length"> · ya firmó {{ (f.firmaron || []).map(nombre).join(', ') }}</ng-container></p>
          </div>
          <span class="kb-badge" [ngClass]="f.alertas ? 'kb-badge-alerta' : 'kb-badge-neutro'">{{ f.alertas ? (f.alertas + (f.alertas === 1 ? ' alerta para mirar' : ' alertas para mirar')) : 'Sin alertas' }}</span>
        </div>
        <div class="flex flex-col gap-[8px] px-[24px] pt-[16px]" *ngIf="f.alertas">
          <ng-container *ngFor="let l of f.liquidaciones">
            <div class="kb-cinta !m-0" *ngFor="let a of l.alertas" role="note">
              <i class="fas fa-exclamation-triangle kb-cinta-icono" aria-hidden="true"></i>
              <span class="min-w-0"><strong class="font-medium">{{ l.code }}.</strong> {{ a.texto }}</span>
            </div>
          </ng-container>
        </div>
        <div class="kb-table-envoltorio">
          <table class="kb-table">
            <thead class="kb-thead"><tr>
              <th class="kb-th">Comercio</th><th class="kb-th">Contrato</th><th class="kb-th kb-th-num">Ventas</th><th class="kb-th kb-th-num">Neto</th>
            </tr></thead>
            <tbody>
              <ng-container *ngFor="let l of f.liquidaciones">
                <tr class="kb-tr">
                  <td class="kb-td">
                    <div class="flex flex-col items-start gap-[4px]">
                      <app-estampa-comercio [codigo]="l.code" [conNombre]="true"></app-estampa-comercio><span class="kb-td-sub" *ngIf="l.atrasada">atrasada</span>
                      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm !w-auto" *ngIf="l.detalle?.pagares?.length" (click)="verPagares(l.code)" [attr.aria-expanded]="abierto.has(l.code)">
                        <i class="fas !text-current" [ngClass]="abierto.has(l.code) ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>{{ abierto.has(l.code) ? 'Ocultar pagarés' : 'Ver ' + l.detalle.pagares.length + ' pagarés' }}</button>
                    </div>
                  </td>
                  <td class="kb-td">{{ l.terms_version }} <span *ngIf="(l.terms_version || '').endsWith('-LEGACY')" class="kb-badge kb-badge-neutro ml-1">legacy · contra CxC</span></td>
                  <td class="kb-td kb-td-num">{{ l.ventas }}</td>
                  <td class="kb-td kb-td-num font-semibold"><app-monto-bs [usd]="l.totales.neto" [bs]="bs(l.totales.neto)" [tasa]="f.tasa"></app-monto-bs></td>
                </tr>
                <tr class="kb-tr" *ngIf="abierto.has(l.code)">
                  <td class="kb-td" colspan="4">
                    <div class="kb-table-envoltorio rounded-md border border-border">
                      <table class="kb-table [&_td]:!px-[10px] [&_th]:!px-[10px]">
                        <thead class="kb-thead"><tr><th class="kb-th">Pagaré</th><th class="kb-th">Fecha</th><th class="kb-th kb-th-num">Crédito</th><th class="kb-th kb-th-num">Comisión</th><th class="kb-th kb-th-num">Neto</th></tr></thead>
                        <tbody>
                          <tr class="kb-tr" *ngFor="let p of l.detalle.pagares">
                            <td class="kb-td font-mono text-xs">{{ p.code }}</td>
                            <td class="kb-td whitespace-nowrap">{{ p.fecha | date:'dd/MM/yyyy':'-0400' }}</td>
                            <td class="kb-td kb-td-num">{{ p.financiado | number:'1.2-2':'es' }}</td>
                            <td class="kb-td kb-td-num">{{ p.comision | number:'1.2-2':'es' }}</td>
                            <td class="kb-td kb-td-num font-semibold">{{ p.neto | number:'1.2-2':'es' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <span class="kb-badge mt-2" [ngClass]="l.detalle.cuadra ? 'kb-badge-exito' : 'kb-badge-peligro'">{{ l.detalle.cuadra ? 'Cuadra con el neto' : 'No cuadra con el neto' }}</span>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
        <div class="kb-card-footer flex-wrap gap-3">
          <ng-container *ngIf="puedeFirmar && !devolviendo">
            <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90" (click)="firmar()" [disabled]="ocupado">{{ ocupado ? 'Firmando…' : 'Firmar' }}</button>
            <button type="button" class="kb-btn kb-btn-outline" (click)="devolviendo = true" [disabled]="ocupado">Devolver…</button>
          </ng-container>
          <div class="flex w-full flex-col gap-2" *ngIf="puedeFirmar && devolviendo">
            <label class="kb-label" for="motivo-devolver">Por qué la devuelves (la ve el tesorero)</label>
            <textarea id="motivo-devolver" class="kb-input min-h-[72px]" [(ngModel)]="motivo"></textarea>
            <div class="flex gap-2">
              <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90" (click)="devolver()" [disabled]="ocupado || !motivo.trim()">Devolver la tanda</button>
              <button type="button" class="kb-btn kb-btn-outline" (click)="devolviendo = false; motivo = ''">Cancelar</button>
            </div>
          </div>
          <p class="kb-hint !m-0" *ngIf="!puedeFirmar && f.solicitud.estado === 'EN_CURSO'">No te toca esta firma: la ves en lectura.</p>
          <a class="kb-btn kb-btn-ghost ml-auto" routerLink="/console/liquidacion" [queryParams]="{ dia: f.dia, vista: 'aprobar' }">Ver en «Por aprobar» (Excel, cobranza)</a>
        </div>
      </section>

      <aside class="kb-card h-fit">
        <div class="kb-card-header"><h2 class="kb-card-title">Historia</h2></div>
        <ol class="m-0 flex list-none flex-col gap-[12px] p-[24px]">
          <li class="border-l-2 border-border pl-3" *ngFor="let e of f.historia">
            <p class="m-0 text-sm font-medium">{{ textoEvento(e) }}</p>
            <p class="m-0 text-xs text-muted-foreground">{{ e.at | date:'dd/MM/yyyy HH:mm':'-0400' }}</p>
          </li>
        </ol>
      </aside>
    </div>
  </ng-container>
</div>
